import GuideOutline from 'Component/guide/outline';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { formatNumber, formatDate, formatBigNumber, formatFixed } from 'Util';
import EventBus from 'Util/eventBus';

const Outline = ({ data }) => {

  const [isActive, setIsActive] = useState(true);

	return (
    <div className={"summary" + (isActive ? ' is-active' : '')}>
      <div className="title">{data.TICKER_NAME} 개요</div>
      <div className="text">{data.outline.SUMMARY}</div>
      <div 
        className="toggle"
        onClick={(e) => {
          e.preventDefault();
          setIsActive(!isActive);
        }}
      >
        <span>{isActive ? '펼치기' : '접기'}</span><i></i>
      </div>
      <div className="info">
        <div className="tit">{data.TICKER_NAME}</div>
        <div className="con">
          <dl className="bold txt_basic">
              <dt>전일종가</dt>
              <dd>{formatNumber(data.outline.PRICE)}원</dd>
          </dl>
          <dl className="bold txt_basic">
              <dt>시가총액</dt>
              <dd>{formatBigNumber(data.outline.MKT_VAL)}원</dd>
          </dl>
          <dl>
              <dt>52주 고가/저가</dt>
              <dd>{formatNumber(data.outline.MIN_52W_PRC)} / {formatNumber(data.outline.MAX_52W_PRC)}원</dd>
          </dl>
          <dl>
              <dt>20일 평균거래액</dt>
              <dd>{formatBigNumber(data.outline.TRD_20D_AMT)}원</dd>
          </dl>
          <dl>
            <dt>
              <span>PER</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  EventBus.emit('guideOutlineEvent', 'per');
                }}
              >
                <img src="/static/images/icon_qm.svg" alt="" />
              </Link>
            </dt>
            <dd>{data.outline.PER ? formatFixed(data.outline.PER, 2) + '배' : '-'}</dd>
          </dl>
          <dl>
            <dt>
              <span>PBR</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  EventBus.emit('guideOutlineEvent', 'pbr');
                }}
              >
                <img src="/static/images/icon_qm.svg" alt="" />
              </Link>
            </dt>
            <dd>{data.outline.PBR ? formatFixed(data.outline.PBR, 2) + '배' : '-'}</dd>
          </dl>
          <dl>
            <dt>
              <span>PSR</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  EventBus.emit('guideOutlineEvent', 'psr');
                }}
              >
                <img src="/static/images/icon_qm.svg" alt="" />
              </Link>
            </dt>
            <dd>{data.outline.PSR ? formatFixed(data.outline.PSR, 2) + '배' : '-'}</dd>
          </dl>
          <dl>
            <dt>
              <span>ROE</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  EventBus.emit('guideOutlineEvent', 'roe');
                }}
              >
                <img src="/static/images/icon_qm.svg" alt="" />
              </Link>
            </dt>
            <dd>{data.outline.ROE ? formatFixed(data.outline.ROE, 2) + '%' : '-'}</dd>
          </dl>
          <dl>
            <dt>
              <span>순부채비율</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  EventBus.emit('guideOutlineEvent', 'der');
                }}
              >
                <img src="/static/images/icon_qm.svg" alt="" />
              </Link>
            </dt>
            <dd>{data.outline.DEBT_RATIO ? formatFixed(data.outline.DEBT_RATIO, 2) + '%' : '-'}</dd>
          </dl>
          <dl>
            <dt>
              <span>배당수익률</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  EventBus.emit('guideOutlineEvent', 'div');
                }}
              >
                <img src="/static/images/icon_qm.svg" alt="" />
              </Link>
            </dt>
            <dd>{data.outline.DIV_RATE ? formatFixed(data.outline.DIV_RATE, 2) + '%' : '-'}</dd>
          </dl>
          <dl>
            <dt>업종</dt>
            <dd>{data.outline.WI26_NM ? data.outline.WI26_NM : '-'}</dd>
          </dl>
          <dl>
            <dt>상장일</dt>
            <dd>{formatDate(data.outline.LIST_DT)}</dd>
          </dl>
        </div>
      </div>
      <GuideOutline />
    </div>
  );
}

export default Outline;
